module.exports = __webpack_public_path__ + "img/wx_tip2.d0e6b445.png";